<template>
  <div
    v-on:click="openDorm()"
    class="dorm-card"
    :class="[
      {
        premium: dorm.is_advert,
        male: dorm.dorm_type_id === 1,
        female: dorm.dorm_type_id === 2
      }
    ]"
  >
    <div class="dorm-card__top">
      <!--"dorm-card-badge" elementi sadece dorm 1. sıra sabit reklamı var ise görünür.-->
      <div class="dorm-card-badge" v-if="dorm.is_advert">
        <div class="badge_in">
          <div class="img_wrp">
            <img
              src="@/assets/img/star-icon-white.svg"
              alt=""
              class="img-fluid"
            />
          </div>
          <span>Popüler</span>
        </div>
      </div>
      <img
        :src="
          dorm.cover
            ? dorm.cover
            : require('@/assets/img/yurtlarburada-default.jpg')
        "
        alt=""
        class="dorm-card__img"
      />
      <div class="dorm-card__overlay">
        <v-button
          class="dorm-card__button"
          :title="panel ? 'Düzenle' : 'İncele'"
        />
      </div>
    </div>
    <div class="dorm-card__cnt">
      <div class="dorm-card__content">
        <div class="dorm-card__title">
          <small>{{ dorm.city.name }}, {{ dorm.district.name }}</small>
          <span class="dorm-card__title-main" :title="dorm.name">
            {{ dorm.name }}
          </span>
        </div>
        <div class="dorm-card-price">
          <div class="dorm-card-price__title">
            {{ getMinPrice(dorm.rooms) }} TL
          </div>
          <div class="dorm-card-price__txt">
            ‘den başlayan<br />oda fiyatları
          </div>
        </div>
      </div>
      <div class="dorm-card__bottom">
        <div
          class="show-tel"
          v-show="dorm.big"
          @click.prevent="showTel"
          v-if="show"
        >
          <span class="show-tel__icon">
            <svg-icon type="icon-phone" />
          </span>
          Telefona Bak
        </div>
        <div class="dorm-card__inf" v-if="dorm.rooms_count">
          <div class="icon-font">
            <svg-icon type="icon-bed" />
          </div>
          <div class="btn-txt">{{ dorm.rooms_count }} kişilik oda</div>
        </div>

        <div v-if="dorm.meal && !dorm.branch_count" class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-food" />
          </div>
          <div class="btn-txt">{{ dorm.meal }} Öğün</div>
        </div>
        <div
          v-else-if="!dorm.meal && !dorm.is_wifi && !dorm.branch_count"
          class="dorm-card__inf"
        >
          <div class="icon-font">
            <svg-icon type="icon-food" />
          </div>
          <div class="btn-txt" disabled>
            Yok
          </div>
        </div>
        <div
          v-else-if="!dorm.meal && dorm.is_wifi && !dorm.branch_count"
          class="dorm-card__inf"
        >
          <div class="icon-font">
            <svg-icon type="icon-wifi" />
          </div>
          <div class="btn-txt">
            Wifi Var
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomCard',
  data() {
    return {
      show: true,
      branchnumber: '',
      branchNames: '',
      distinctCities: ''
    }
  },
  props: {
    dorm: Object,
    panel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showTel() {
      this.show = false
    },
    openDorm() {
      window.localStorage.setItem('dormid', this.dorm.id)
      let url =
        'http://www.yurtlarburada.com/' + this.dorm.slug + '-y-' + this.dorm.id
      window.localStorage.setItem('url', url)
      window.localStorage.setItem('description', this.dorm.description)
      window.localStorage.setItem('name', this.dorm.name)
      // window.localStorage.setItem('city', this.dorm.city.slug)
      window.localStorage.setItem('slug', this.dorm.slug + '-y-' + this.dorm.id)
      let extension = this.$helpers.mobileCheck() ? '_self' : '_blank'
      if (this.panel) {
        window.open(
          `${window.location.origin}/yurt-paneli/yurtlar/odalar/${this.dorm.slug}-y-${this.dorm.id}`,
          extension
        )
        return
      }
      window.open(
        `${window.location.origin}/${this.dorm.slug}-y-${this.dorm.id}#rooms`,
        extension
      )
    },
    getMinPrice(rooms) {
      let minPrice = 0
      for (let i = 0; i < rooms.length; i++) {
        const room = rooms[i]
        minPrice = room.daily_price > minPrice ? room.daily_price : minPrice
      }
      return minPrice
    }
  },
  computed: {
    getCapacity() {
      if (this.dorm && this.dorm.capacity) {
        return this.dorm.capacity.replace('kişi', '')
      } else {
        return ''
      }
    }
  },
  created() {
    console.log('dorm: ', this.dorm)
    if (!this.dorm.city) {
      this.dorm.city = {
        name: ''
      }
    }

    if (!this.dorm.district) {
      this.dorm.district = {
        name: ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/components/dorm-card';
.mywashed {
  background-blend-mode: lighten;
}
</style>
